(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hyrley-quote-product-links"] && !Shopify.designMode) return;
  try {
    (() => {
  const instances = new Map();
  const init = (scope) => {
    scope.querySelectorAll('.hp-sb-quote').forEach(container => {
      if (instances.has(container)) return;
      const links = container.querySelector('[data-hp-quote-product-links]');
      if (!links) return;
      const choices = [...links.querySelectorAll('[data-hp-quote-choice]')];
      const status = links.querySelector('[data-hp-quote-status]');
      let pending = null;
      let recovery = null;
      let timer;
      const loadStartedAt = Date.now();
      let initSeenAt = null;
      const initialLoadTimer = setInterval(() => {
        if (!container.isConnected || container.querySelector('#sb-cfp2c-form, #sb-cfp2ms-root form, .sb_quote_form form') || Date.now() - loadStartedAt >= 60000) {
          clearInterval(initialLoadTimer);
          return;
        }
        const page = container.querySelector('.rfq_page_content[data-rfq-init]');
        if (!page) return;
        if (initSeenAt === null) initSeenAt = Date.now();
        if (Date.now() - initSeenAt < 6000 || typeof window.loadrfqScriptFileForPage !== 'function' || !(window.CFPCompactV2 || window.CFPMultiStepV2)) return;
        clearInterval(initialLoadTimer);
        page.removeAttribute('data-rfq-init');
        window.loadrfqScriptFileForPage();
      }, 500);
      const anchor = document.createComment('hp-quote-product-links');
      links.before(anchor);
      const basketRows = () => [...container.querySelectorAll('#sb-cfp2c-root .sb-cfp2-basket-item[data-variant-id]')];
      const selected = button => basketRows().some(row => row.dataset.variantId === button.dataset.variantId);
      const sync = () => {
        const ready = !!container.querySelector('#cfp2c-srch-input') && !!container.querySelector('#sb-cfp2c-basket-sec');
        choices.forEach(button => {
          const added = selected(button);
          button.setAttribute('aria-pressed', String(added));
          button.disabled = !ready || !!pending || !!recovery || added || !button.dataset.variantId || !button.dataset.productTitle;
        });
      };
      const finish = success => {
        if (!pending) return;
        const button = pending.button;
        pending = null;
        clearTimeout(timer);
        links.setAttribute('aria-busy', 'false');
        links.dataset.errorState = String(!success);
        status.textContent = success ? button.getAttribute('aria-label') + ' — ' + links.dataset.added : links.dataset.error;
        sync();
      };
      const place = () => {
        if (recovery) {
          const form = container.querySelector('#sb-cfp2c-form');
          if (!form && !recovery.started && typeof window.loadrfqScriptFileForPage === 'function') {
            const page = container.querySelector('.rfq_page_content');
            if (page) {
              recovery.started = true;
              page.removeAttribute('data-rfq-init');
              window.loadrfqScriptFileForPage();
            }
          } else if (form && recovery.started) {
            const saved = recovery.fields;
            recovery = null;
            [...form.querySelectorAll('input[name], textarea[name], select[name]')].forEach((field, index) => {
              const previous = saved[index];
              if (!previous || previous.name !== field.name || previous.type !== field.type) return;
              if (field.type === 'file') {
                if (previous.files.length && typeof DataTransfer === 'function') {
                  const transfer = new DataTransfer();
                  previous.files.forEach(file => transfer.items.add(file));
                  field.files = transfer.files;
                }
              } else if (field.type === 'radio' || field.type === 'checkbox') {
                field.checked = previous.checked;
              } else {
                field.value = previous.value;
              }
              field.dispatchEvent(new Event('change', { bubbles: true }));
            });
            status.textContent = '';
          }
        }
        const toolbar = container.querySelector('#sb-cfp2c-root .sb-cfp2-col-left-scroll .sb-cfp2-col-top-row');
        const target = toolbar || anchor;
        if (target.nextSibling !== links) target.after(links);
        if (pending) {
          if (selected(pending.button)) {
            finish(true);
          } else if (!pending.clicked) {
            const input = container.querySelector('#cfp2c-srch-input');
            if (input && input.value === pending.query) {
              const result = [...container.querySelectorAll('#cfp2c-srch-results .sb-cfp2-srch-item')].find(item => item.dataset.handle === pending.button.dataset.handle);
              if (result) {
                pending.clicked = true;
                result.click();
              }
            }
          }
        }
        sync();
      };
      const choose = event => {
        const button = event.target.closest('[data-hp-quote-choice]');
        if (!button || button.disabled || pending || selected(button)) return;
        const input = container.querySelector('#cfp2c-srch-input');
        if (!input) return;
        const query = '"' + button.dataset.productTitle.replace(/"/g, '') + '"';
        pending = { button, query, clicked: false };
        links.setAttribute('aria-busy', 'true');
        links.dataset.errorState = 'false';
        status.textContent = links.dataset.adding;
        sync();
        timer = setTimeout(() => finish(selected(button)), 15000);
        input.value = query;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      };
      const preserveLastRemoval = event => {
        const remove = event.target.closest('.sb-cfp2-bskt-rm');
        if (!remove || basketRows().length !== 1) return;
        const form = container.querySelector('#sb-cfp2c-form');
        if (!form) return;
        recovery = {
          started: false,
          fields: [...form.querySelectorAll('input[name], textarea[name], select[name]')].map(field => ({
            name: field.name,
            type: field.type,
            value: field.value,
            checked: field.checked,
            files: field.type === 'file' ? [...field.files] : []
          }))
        };
        sync();
      };
      container.addEventListener('click', preserveLastRemoval, true);
      links.addEventListener('click', choose);
      const observer = new MutationObserver(place);
      observer.observe(container, { childList: true, subtree: true });
      instances.set(container, () => {
        observer.disconnect();
        clearTimeout(timer);
        clearInterval(initialLoadTimer);
        links.removeEventListener('click', choose);
        container.removeEventListener('click', preserveLastRemoval, true);
      });
      place();
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((cleanup, container) => {
      if (event.target.contains(container)) {
        cleanup();
        instances.delete(container);
      }
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
